const MODAL_MARGIN = 40;
const NAV_HEIGHT = 60;

const getConstrainedHeight = (viewPortHeight, inIframe) => {
  if (!viewPortHeight) {
    return undefined;
  }

  if (!inIframe) {
    return viewPortHeight;
  }

  return viewPortHeight - ((MODAL_MARGIN * 2) + NAV_HEIGHT);
};

export default getConstrainedHeight;
